"use client";

import { motion } from "framer-motion";
import { FaUser, FaEnvelope } from "react-icons/fa";

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0 },
};

export default function AboutFounder() {
    return (
        <section className="relative py-24 bg-[#0c2c4d] text-white font-sans w-full overflow-hidden">
            <div className="relative max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">

                {/* VIDEO Founder */}
                <motion.div
                    className="rounded-2xl shadow-xl bg-white overflow-hidden w-full h-80 md:h-[28rem]"
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.7 }}
                >
                    <video
                        src="/assets/DraftResource_1762505238.391840.MOV"
                        autoPlay
                        loop
                        muted
                        controls
                        className="w-full h-full object-contain rounded-2xl"
                    />
                </motion.div>

                {/* Thông tin Founder */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    variants={fadeUp}
                    transition={{ duration: 0.7 }}
                >
                    <h3 className="text-3xl md:text-4xl font-extrabold mb-4 flex items-center">
                        <FaUser className="text-yellow-500 mr-3" />
                        Mỹ Diệp
                    </h3>
                    <p className="text-lg font-semibold mb-2 text-yellow-300">Founder & CEO</p>
                    <p className="text-white/90 leading-relaxed">
                        Mỹ Diệp là người sáng lập và điều hành dự án với tầm nhìn chiến lược,
                        tận tâm xây dựng những khu nghỉ dưỡng và đô thị biển đẳng cấp,
                        mang lại giá trị bền vững cho cộng đồng và nhà đầu tư. Với kinh nghiệm nhiều năm
                        trong lĩnh vực bất động sản cao cấp, cô luôn đặt chất lượng, uy tín và sự hài lòng
                        của khách hàng lên hàng đầu.
                    </p>

                    <p className="mt-4 text-yellow-200 italic">
                        “Tầm nhìn của tôi là kết nối thiên nhiên – kiến trúc – cộng đồng, tạo ra không gian sống lý tưởng cho tất cả mọi người.”
                    </p>

                    {/* Nút Liên hệ */}
                    <div className="mt-6">
                        <a
                            href="mailto:mydiep@example.com"
                            className="inline-flex items-center gap-2 px-6 py-3 bg-yellow-500 text-[#0c2c4d] font-semibold rounded-lg hover:bg-yellow-400 transition"
                        >
                            <FaEnvelope />
                            Liên hệ
                        </a>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
